import type { CoreAcessoRotinaUsuarioResponse } from "@r3backend/src/modules/Usuarios/app/DTO/coreAcessoRotina.dto";
import type { PagesMenu, Rotina, rotinasMenu } from "~/types/pagesMenu";
import useRotinasExpedicao from "./menus/rotinas/expedicao/useRotinasExpedicao";
import useRotinasRecepcao from "./menus/rotinas/recepcao/useRotinasRecepcao";
import useRotinasConvocacaoAtiva from "./menus/rotinas/convocacaoAtiva/useRotinasConvocacaoAtiva";
import useRotinasNaoConformidade from "./menus/rotinas/naoConformidade/useRotinasNaoConformidade";
import useRotinasCadastro from "./menus/rotinas/cadastro/useRotinasCadastro";
import useRotinasInventario from "./menus/rotinas/inventario/useRotinasInventario";
import useRotinasPCE from "./menus/rotinas/pce/useRotinasPCE";
import useRotinasConsulta, { CATEGORIA_CONSULTA } from "./menus/rotinas/consulta/useRotinasConsulta";
import useRotinasAcompanhamentos from "./menus/rotinas/acompanhamentos/useRotinasAcompanhamentos";
import { temAcessoConsulta } from "./menus/rotinas/consulta/acessoConsulta";
import type {
	RotinasRecepcao
} from "~/composables/menus/rotinas/recepcao/rotinas";
import type {
	RotinasExpedicao
} from "~/composables/menus/rotinas/expedicao/rotinas";
import type {
	RotinasConvocacaoAtiva
} from "~/composables/menus/rotinas/convocacaoAtiva/rotinas";


export type TelasHarpiaWMS = RotinasRecepcao | RotinasExpedicao | RotinasConvocacaoAtiva;
// type menu = {
//   label: string;
//   icon?: string;
//   items: { label: string; to: string }[];
// };

const rotinas: Rotina[] = [
	// {
	//   categoria: "Expedição",
	//   label: "Averiguação de volumes na expedição",
	//   nome: "mni_ColetorDadosAveriguacaoVolumes",
	//   tela: "B321"
	// }
];

const menusColetor: PagesMenu[] = [
	{
		label: "Acompanhamentos",
		icon: "pi pi-fw pi-chart-line",
		items: [],
	},
	{
		label: "Recepção",
		icon: "pi pi-fw pi-home",
		items: [

		],
	},
	{
		label: "Expedição",
		icon: "pi pi-fw pi-home",
		items: [

		]
	},
	{
		label: "Inventário",
		icon: "pi pi-fw pi-home",
		items: [

		],
	},
	{
		label: "PCE",
		icon: "pi pi-fw pi-home",
		items: [

		],
	},
	{
		// Categoria trazida no r187, com B11 (dados logísticos) e B12 (código de
		// barras). Sem esta entrada as rotinas existem mas não têm onde aparecer:
		// o laço abaixo casa `rotina.categoria` contra os labels desta lista, e o
		// que não casa é descartado em silêncio.
		label: "Cadastro",
		icon: "pi pi-fw pi-home",
		items: [],
	},
	{
		label: "Convocação Ativa",
		icon: "pi pi-fw pi-home",
		items: []
	},
	{
		// "B37 - Gestão de Não Conformidade" do `SIST_MAINFORM`. Entra logo abaixo
		// de Convocação Ativa, e por ora traz só a B371.
		label: "Gestão de Não Conformidade",
		icon: "pi pi-fw pi-exclamation-triangle",
		items: [],
	},
	{
		// "B4 - Consultas" do `SIST_MAINFORM`. Estava fora do menu: as consultas
		// viviam num botão do `index.vue` que abria um modal com a lista.
		label: "Consulta",
		icon: "pi pi-fw pi-search",
		items: [],
	}
];

function adicionarRotinasExpedicao() {
	const rotinasExpedicao = useRotinasExpedicao();

	rotinasExpedicao.forEach((rotina) => {
		if (!rotinas.includes(rotina))
			rotinas.push(rotina);
	});
}

function adicionarRotinasRecepcao() {
	const rotinasRecepcao = useRotinasRecepcao();

	rotinasRecepcao.forEach((rotina) => {
		if (!rotinas.includes(rotina))
			rotinas.push(rotina);
	});
}

function adicionarRotinasCadastro() {
	const rotinasCadastro = useRotinasCadastro();

	rotinasCadastro.forEach((rotina) => {
		if (!rotinas.includes(rotina))
			rotinas.push(rotina);
	});
}

function adicionarRotinasInventario() {
	const rotinasInventario = useRotinasInventario();

	rotinasInventario.forEach((rotina) => {
		if (!rotinas.includes(rotina))
			rotinas.push(rotina);
	});
}

function adicionarRotinasPCE() {
	useRotinasPCE().forEach((rotina) => {
		if (!rotinas.includes(rotina)) rotinas.push(rotina);
	});
}

function adicionarRotinasConsulta() {
	const rotinasConsulta = useRotinasConsulta();

	rotinasConsulta.forEach((rotina) => {
		if (!rotinas.includes(rotina))
			rotinas.push(rotina);
	});
}

function adicionarRotinasAcompanhamentos() {
	useRotinasAcompanhamentos().forEach((rotina) => {
		if (!rotinas.includes(rotina)) rotinas.push(rotina);
	});
}

function adicionarRotinasConvocacaoAtiva() {
	const rotinasConvocacaoAtiva = useRotinasConvocacaoAtiva();

	rotinasConvocacaoAtiva.forEach((rotina) => {
		if (!rotinas.includes(rotina))
			rotinas.push(rotina);
	});
}

function adicionarRotinasNaoConformidade() {
	useRotinasNaoConformidade().forEach((rotina) => {
		if (!rotinas.includes(rotina)) rotinas.push(rotina);
	});
}

async function rotinasDoUsuario(userStore, fetch) {
	const rotinas = await fetch.get("/api/usuarios/acessorotinas", {
		params: { USUARIO: userStore.userID }
	}) as { response: CoreAcessoRotinaUsuarioResponse };

	return rotinas;
}

async function definirRotinasDisponiveis(userStore, fetch) {
	// menusColetor = store.userRoutines;
	adicionarRotinasExpedicao();
	adicionarRotinasRecepcao();
	adicionarRotinasConvocacaoAtiva();
	adicionarRotinasNaoConformidade();
	adicionarRotinasCadastro();
	adicionarRotinasInventario();
	adicionarRotinasPCE();
	adicionarRotinasConsulta();
	adicionarRotinasAcompanhamentos();
	const rotinasUsuario = (await rotinasDoUsuario(userStore, fetch)).response.ACEUSU_ID_MENU_PF;
	menusColetor.forEach(menu => { menu["items"] = [] });
	rotinas.forEach(async (rotina) => {
		// if (await checarRotinaJaAdicionadaNoStore({ categoria: rotina.categoria, rotina: rotina.nome }) === false) {
		const temAcesso = rotina.categoria === "Acompanhamentos"
			? true
			: rotina.categoria === CATEGORIA_CONSULTA
			? temAcessoConsulta(rotinasUsuario, rotina.nome)
			: rotinasUsuario.includes(rotina.nome);

		if (temAcesso) {
			for (let i = 0; i < menusColetor.length; i++) {
				if (menusColetor[i].label === rotina.categoria) {
					if (!menusColetor[i].items.includes({ label: rotina.label, to: `/${rotina.rotina}`, visible: rotina.disponivel, tela: rotina.tela as unknown as rotinasMenu }))
						menusColetor[i].items.push({ label: rotina.label, to: `/${rotina.rotina}`, visible: rotina.disponivel, tela: rotina.tela as unknown as rotinasMenu });
				}
			}
			// for (let i = 0; i < store.userRoutines.length; i++) {
			//   if (store.userRoutines[i].label === rotina.categoria) {
			//     if (!store.userRoutines[i].items.includes({ label: rotina.label, to: `/${rotina.tela}` }))
			//       store.userRoutines[i].items.push({ label: rotina.label, to: `/${rotina.tela}` });
			//   }
			// }
			// menusColetor.forEach(menu => {
			//   console.log("Vai colocar dentro da categoria")
			//   if (menu.label === rotina.categoria) menu.items.push({ label: rotina.nome, to: `/${rotina.tela}` })
			// })
		}
		// }
	});
}

async function checarRotinaJaAdicionadaNoStore(params: { categoria: string, rotina: string }): Promise<boolean> {
	const store = useUserStore();

	const categoriaRotina = store.userRoutines.find(rotinaJaAdicionada => rotinaJaAdicionada.label === params.categoria);

	if (categoriaRotina) {
		console.log("Categoria: ", categoriaRotina)
		const nomeRotina = categoriaRotina.items.find(rotina => rotina.label === params.rotina);
		if (nomeRotina) {
			console.log(`Rotina ${params.rotina} já adicionada`)
			return true;
		}
		else return false;
	}

	return false;
}

export default async function () {
	// menusColetor = [
	//   {
	//     label: "Recepção",
	//     icon: "pi pi-fw pi-home",
	//     items: [

	//     ],
	//   },
	//   {
	//     label: "Expedição",
	//     icon: "pi pi-fw pi-home",
	//     items: [

	//     ],
	//   },
	//   {
	//     label: "Inventário",
	//     icon: "pi pi-fw pi-home",
	//     items: [

	//     ],
	//   },
	//   {
	//     label: "PCD",
	//     icon: "pi pi-fw pi-home",
	//     items: [

	//     ],
	//   },
	//   {
	//     label: "Convocação Ativa",
	//     icon: "pi pi-fw pi-home",
	//     items: [

	//     ]
	//   },
	// ];

	menusColetor.forEach((menu) => {
		menu['items'] = [];
	})
	const { $r3fetchdata } = useNuxtApp();
	const userStore = useUserStore();
	userStore.setUserRoutines([]);

	try {
		await definirRotinasDisponiveis(userStore, $r3fetchdata);
	}
	catch (erro) {
		// Não persistir menu vazio quando a busca falha.
		//
		// O userStore é persistido: gravar as categorias sem itens aqui fazia
		// a tela ficar sem botões de rotina de forma definitiva, porque a
		// próxima carga via `userRoutines` já preenchido e não tentava de novo.
		// Deixando vazio, a próxima montagem refaz a busca.
		console.error("[menus] falha ao carregar as rotinas do usuário:", erro);
		userStore.setUserRoutines([]);
		throw erro;
	}

	const carregouAlgumaRotina = menusColetor
		.some(menu => (menu.items?.length ?? 0) > 0);

	if (!carregouAlgumaRotina) {
		console.warn(
			"[menus] nenhuma rotina do catálogo local casou com as permissões do usuário — "
			+ "menu não será persistido para permitir nova tentativa",
		);
		userStore.setUserRoutines([]);
		return;
	}

	userStore.setUserRoutines(menusColetor);

	// }
}
